import {
  Popup as SemanticPopup,
  PopupProps as SemanticPopupProps,
} from 'semantic-ui-react'
import { createGlobalStyle } from 'styled-components'

import { CSSProperties } from 'react'
import { PopupWrapper } from './Styles'

interface PopupProps extends SemanticPopupProps {
  inline?: boolean
  style?: CSSProperties
}

const GlobalStyle = createGlobalStyle`
  .ui.inverted.popup {
    background: ${props => props.theme.colors.abyss};

    span {
      color: #fff;
    }

    &&& {

      &::before {
        background: ${props => props.theme.colors.abyss};
      }
    }
  }
`

const Popup = ({ inline = true, style = {}, onClose, ...rest }: PopupProps) => (
  <PopupWrapper inline={inline}>
    <GlobalStyle />

    <SemanticPopup
      style={{
        border: !rest.inverted ? '0.5px solid #bdcbd0' : 0,
        boxShadow: '0px 2px 12px -5px rgba(0, 46, 62, 0.1)',
        ...style,
      }}
      delay={{ show: 0, hide: 0 }}
      onClose={(e, data) => {
        if (onClose) {
          onClose(e, data)
        }
      }}
      {...rest}
    />
  </PopupWrapper>
)

export default Popup
